import { render, staticRenderFns } from "./TheHeaderStudentCustom.vue?vue&type=template&id=0e0d7c0d&"
import script from "./TheHeaderStudentCustom.vue?vue&type=script&lang=js&"
export * from "./TheHeaderStudentCustom.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderStudentCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports